export default [
  { path: '', component: () => import('layouts/App'), children: [
    { path: '', component: () => import('layouts/main/Index'), children: [
      { path: '', name: 'main-page', icon: 'genderless', component: () => import('pages/main-page/Index'), },
      { path: 'scan-configuration', name: 'scan-configuration', icon: 'genderless', component: () => import('pages/scan-configuration/VerificationPage'), },
      { path: 'action-page/:faceData', name: 'action-page', icon: 'genderless', component: () => import('pages/action-page/Index'), },
      { path: 'service-page', name: 'service-page', icon: 'genderless', component: () => import('pages/service-page/Index'), },
      { path: 'scan-page', name: 'scan-page', icon: 'genderless', component: () => import('pages/scan-page/Index'), },
    ], },
  ], },
]

